import {axios} from '@/utils/request'

/**
 * 1、查询体检单项管理
 * @author LIWEI
 * @date 2022-04-07 15:21:29
 */
export function medProjectPage(parameter) {
  return axios({
    url: '/baMedicalProject/page',
    method: 'get',
    params: parameter
  })
}

/**
 * 2、发布、恢复、下架 体检单项
 * @author wanglong
 * @date 2024/10/24 17:09
 */
export function updateExamProjectState(params) {
  return axios({
    url: '/baMedicalProject/updateExamProjectState',
    method: 'post',
    data: params
  })
}

/**
 * 3、新增体检单项
 * @author wanglong
 * @date 2024/10/25 14:19
 */
export function addExamProject(params) {
  return axios({
    url: '/baMedicalProject/add',
    method: 'post',
    data: params
  })
}

/**
 * 4、获取体检科室
 * @author wanglong
 * @date 2024/10/25 14:18
 */
export function qryExamDeptList() {
  return axios({
    url: '/baMedicalProject/qryExamDeptList',
    method: 'post',
  })
}

/**
 * 5、修改体检单项
 * @author wanglong
 * @date 2024/10/25 15:05
 */
export function editExamProject(params) {
  return axios({
    url: '/baMedicalProject/edit',
    method: 'post',
    data: params
  })
}


export function medicalorderExport(params) {

}
